module.exports = __webpack_public_path__ + "assets/image/twoInOne/shopmall.png";